import { render, staticRenderFns } from "./ParticipantPermission.vue?vue&type=template&id=b79a40e6&scoped=true&"
import script from "./ParticipantPermission.vue?vue&type=script&lang=js&"
export * from "./ParticipantPermission.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantPermission.vue?vue&type=style&index=0&id=b79a40e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79a40e6",
  null
  
)

export default component.exports